import type { ReactNode } from 'react'

import '@hotmart/cosmos/dist/card/card-footer.css'

export interface CardFooterProps {
  children: ReactNode
  className?: string
}

const CardFooter = ({ children, className = '' }: CardFooterProps) => {
  return <hot-card-footer class={className}>{children}</hot-card-footer>
}

export default CardFooter
